import { Theme } from '@mui/material';

export const inviteBannerStyles = (theme: Theme) => ({
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
		padding: { xs: '30px 15px 0', md: '64px 15px 0' },
		borderRadius: '12px',
	},
});
